import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function t(field, lang = 'en') {
  if (!field) return '';
  return field[lang] || field.en || '';
}

export default function CookiePolicy() {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('ets_lang');
    if (savedLang) setLang(savedLang);
  }, []);

  const content = {
    back: { en: '← Back to Home', zh: '← 返回首頁' },
    title: { en: 'Cookie Policy', zh: 'Cookie 政策' },
    lastUpdated: { en: 'Last updated: ', zh: '最後更新：' },
    
    sec1Title: { en: '1. What are Cookies?', zh: '1. 什麼是 Cookie？' },
    sec1P1: { en: 'Cookies are small text files that are placed on your computer or mobile device when you visit our website. They are widely used to make websites work more efficiently and provide information to the owners of the site.', zh: 'Cookie 是您造訪我們網站時放置在您電腦或行動裝置上的小型文字檔案。它們被廣泛用於使網站更有效地運作，並向網站擁有者提供資訊。' },
    
    sec2Title: { en: '2. How We Use Cookies', zh: '2. 我們如何使用 Cookie' },
    sec2P1: { en: 'Every Talent Shines Academy (ETS) uses cookies to enhance your browsing experience, analyze site traffic, and understand where our audience comes from. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.', zh: 'Every Talent Shines Academy (ETS) 使用 cookie 來增強您的瀏覽體驗、分析網站流量並了解我們的受眾來源。這些 cookie 可能會追蹤您在網站上停留的時間以及您造訪的頁面等資訊，以便我們能夠繼續製作引人入勝的內容。' },
    sec2P2: { en: 'We use both session cookies (which expire once you close your web browser) and persistent cookies (which stay on your device until you delete them) to provide you with a more personal and interactive experience on our website.', zh: '我們使用工作階段 cookie（當您關閉網頁瀏覽器時過期）和持久性 cookie（保留在您的裝置上直到您將其刪除），在我們的網站上為您提供更個人化和互動的體驗。' },
    
    sec3Title: { en: '3. Types of Cookies We Use', zh: '3. 我們使用的 Cookie 類型' },
    sec3P1: { en: '• Essential Cookies: Necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.', zh: '• 基本 Cookie：為網站正常運作所必需。它們啟用基本功能，如頁面導航和存取網站的安全區域。' },
    sec3P2: { en: '• Analytical/Performance Cookies: Allow us to recognize and count the number of visitors and see how visitors move around our website when they are using it. This helps us improve the way our website works.', zh: '• 分析/效能 Cookie：允許我們識別和計算訪客數量，並了解訪客在使用我們的網站時如何瀏覽。這有助於我們改進網站的運作方式。' },
    sec3P3: { en: '• Functionality Cookies: Used to recognize you when you return to our website. This enables us to personalize our content for you and remember your preferences.', zh: '• 功能性 Cookie：用於在您返回我們的網站時識別您的身分。這使我們能夠為您個人化我們的內容並記住您的偏好。' },
    
    sec4Title: { en: '4. Managing Cookies', zh: '4. 管理 Cookie' },
    sec4P1: { en: 'You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed. If you do this, however, you may have to manually adjust some preferences every time you visit a site and some services and functionalities may not work.', zh: '您可以根據需要控制和/或刪除 cookie。您可以刪除電腦上已有的所有 cookie，並且可以設定大多數瀏覽器以防止放置它們。但如果您這樣做，每次造訪網站時您可能需要手動調整某些偏好設定，且某些服務和功能可能無法運作。' },
    
    sec5Title: { en: '5. Contact Us', zh: '5. 聯絡我們' },
    sec5P1: { en: 'If you have any questions about our Cookie Policy, please contact us at info@etsacademy.com.', zh: '如果您對我們的 Cookie 政策有任何疑問，請透過 info@etsacademy.com 聯絡我們。' }
  };

  return (
    <div style={{ backgroundColor: '#111111', minHeight: '100vh', color: '#f5f5f5', padding: '40px 20px', fontFamily: "'Outfit', sans-serif" }}>
      <div style={{ maxWidth: 800, margin: '0 auto', backgroundColor: '#1a1a1a', padding: 40, borderRadius: 16, border: '1px solid rgba(255,255,255,0.1)' }}>
        <Link to="/" style={{ color: '#c04060', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600, marginBottom: 32 }}>
          {t(content.back, lang)}
        </Link>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1 style={{ fontSize: 32, fontWeight: 700, color: '#fff', fontFamily: "'Playfair Display', serif", margin: 0 }}>{t(content.title, lang)}</h1>
          
          <div style={{ display: 'flex', backgroundColor: '#333', borderRadius: 20, padding: 4 }}>
            <button 
              onClick={() => { setLang('en'); localStorage.setItem('ets_lang', 'en'); }}
              style={{ background: lang === 'en' ? '#c04060' : 'transparent', color: '#fff', border: 'none', borderRadius: 16, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
            >EN</button>
            <button 
              onClick={() => { setLang('zh'); localStorage.setItem('ets_lang', 'zh'); }}
              style={{ background: lang === 'zh' ? '#c04060' : 'transparent', color: '#fff', border: 'none', borderRadius: 16, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
            >繁中</button>
          </div>
        </div>
        
        <div style={{ lineHeight: 1.6, fontSize: 15, color: 'rgba(255,255,255,0.8)' }}>
          <p style={{ marginBottom: 16 }}>{t(content.lastUpdated, lang)}{new Date().toLocaleDateString()}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec1Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec1P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec2Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec2P1, lang)}</p>
          <p style={{ marginBottom: 16 }}>{t(content.sec2P2, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec3Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec3P1, lang)}</p>
          <p style={{ marginBottom: 16 }}>{t(content.sec3P2, lang)}</p>
          <p style={{ marginBottom: 16 }}>{t(content.sec3P3, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec4Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec4P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec5Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec5P1, lang)}</p>
        </div>
      </div>
    </div>
  );
}
